import type { FrontendOnlyColumn } from '@ipfabric/utils';
import { inventorySitesActionsColumn } from 'components/ApiTablePage/actionsColumns/inventorySitesActionsColumn';
import { pathVerificationsActionsColumn } from './actionsColumns/pathVerificationsActionsColumn';

// The AIM tables have no actions column: their triggers live in the columns whose
// data they produce — see `apiTableColumnOverridesMap`.
export const apiTableActionsColumnsMap: {
  [key: string]: FrontendOnlyColumn<any>;
} = {
  '/technology/routing/path-verifications': pathVerificationsActionsColumn,
  '/inventory/sites/overview': inventorySitesActionsColumn,
};
